export const EMAIL_ERROR_MSG = '올바른 이메일을 입력해주세요.'
const PASSWORD_ERROR_MSG = '올바른 비밀번호를 입력해주세요.'
const VERIFICATION_CODE_ERROR_MSG = '인증번호가 올바른지 확인해주세요.'

export const formOptions = {
  EMAIL: {
    required: EMAIL_ERROR_MSG,
    pattern: {
      value: /^[\w-\.]+@([\w-]+\.)+[\w-]{2,4}$/g,
      message: EMAIL_ERROR_MSG,
    },
    minLength: {
      value: 6,
      message: EMAIL_ERROR_MSG,
    },
    maxLength: {
      value: 24,
      message: EMAIL_ERROR_MSG,
    },
  },
  PASSWORD: {
    required: PASSWORD_ERROR_MSG,
    maxLength: {
      value: 20,
      message: PASSWORD_ERROR_MSG,
    },
  },
  PHONE_NUMBER: {
    pattern: {
      value: /^01(?:0|1|[6-9])(?:\d{3}|\d{4})\d{4}$/,
      message: '올바른 휴대폰 번호를 입력해주세요.',
    },
  },
  VERIFICATION_CODE: {
    pattern: {
      value: /^[0-9]*$/,
      message: VERIFICATION_CODE_ERROR_MSG,
    },
    maxLength: {
      value: 6,
      message: VERIFICATION_CODE_ERROR_MSG,
    },
  },
  NAME: {
    required: '이름을 입력해주세요',
    minLength: {
      value: 2,
      message: '이름은 2자 이상으로 입력해주세요',
    },
    maxLength: {
      value: 10,
      message: '이름은 10자 이하로 입력해주세요',
    },
  },
  NICKNAME: {
    required: '닉네임을 입력해주세요',
    minLength: {
      value: 3,
      message: '닉네임은 3자 이상 입력해주세요',
    },
    maxLength: {
      value: 10,
      message: '닉네임은 10자 이하로 입력해주세요',
    },
  },
  TITLE: {
    required: '제목을 입력해주세요',
    maxLength: {
      value: 40,
      message: '제목은 40자 이하로 입력해주세요',
    },
  },
}
